// extracted by mini-css-extract-plugin
export default {"tabs":"tabs--cB1py"};